const deviationReport = {
  namespaced: true,
  state: {
    availableStops: [],
    availableVehicles: [],
  },
  mutations: {
    updateAvailableStops(state, newList) {
      state.availableStops = newList
    },
    updateAvailableVehicles(state, newList) {
      state.availableVehicles = newList
    },
  },
  actions: {
    getAvailableStops(context) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/deviationreport2/availableStops')
          .then((response) => {
            context.commit('updateAvailableStops', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getAvailableVehicles(context) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/deviationreport2/availableVehicles')
          .then((response) => {
            context.commit('updateAvailableVehicles', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    lineDeviationGenerateAndExportXls(context, data) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get(
            '/traveller/restui/deviationreport2/generateByLineAndExportXls',
            { params: data, responseType: 'blob' }
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    stopDeviationGenerateAndExportXls(context, data) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get(
            '/traveller/restui/deviationreport2/generateByStopAndExportXls',
            { params: data, responseType: 'blob' }
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    vehicleDeviationGenerateAndExportXls(context, data) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get(
            '/traveller/restui/deviationreport2/generateByVehicleAndExportXls',
            { params: data, responseType: 'blob' }
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    lineDeviationGenerateAndExportCsv(context, data) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get(
            '/traveller/restui/deviationreport2/generateByLineAndExportCsv',
            { params: data, responseType: 'blob' }
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    stopDeviationGenerateAndExportCsv(context, data) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get(
            '/traveller/restui/deviationreport2/generateByStopAndExportCsv',
            { params: data, responseType: 'blob' }
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    vehicleDeviationGenerateAndExportCsv(context, data) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get(
            '/traveller/restui/deviationreport2/generateByVehicleAndExportCsv',
            { params: data, responseType: 'blob' }
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
}
export default deviationReport
